module.exports = __webpack_public_path__ + "img/Group 7071@2x.27cf682c.png";